<template>
  <router-link
    class="generic-menu-item py-4"
    :data-hover-dot-target='`{"x": ${dotOffsetX}, "y": ${dotOffsetY}}`'
    @click.native="$emit('click')"
    :class="{disabled: !enabled, 'force-active': forceActive}"
    :to="to"
    :exact="exact"
    :replace="replace"
    data-cursor-target="left center"
  >
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  name: 'GenericMenuItem',
  props: {
    to: {
      required: false
    },
    enabled: {
      required: false,
      default: true
    },
    exact: {
      type: Boolean,
      required: false,
      default: false
    },
    replace: {
      type: Boolean,
      required: false,
      default: false
    },
    forceActive: {
      type: Boolean,
      required: false,
      default: false
    },
    dotOffsetX: {
      type: Number,
      require: false,
      default: -20
    },
    dotOffsetY: {
      type: Number,
      require: false,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>

.generic-menu-item {
  display: block;
  font-family: $heading-font-family;
  font-size: 3rem;
  line-height: 1;

  transition: color 0.3s, opacity, 0.3s, transform 0.7s $ease-in-out-quad;
  will-change: color, transform;
  backface-visibility: hidden;

  @include breakpoint('lg-and-down') {
    font-size: 2.2rem;
  }
  @include breakpoint('sm-and-down') {
    font-size: 1.6rem;
  }

  &.disabled {
    pointer-events: none;
    opacity: 0.5;
  }

  // &::before {
  //   position: absolute;
  //   content: '';
  //   width: 5px;
  //   height: 5px;
  //   top: 0;
  //   left: -20px;
  //   border-radius: 50%;
  //   opacity: 0;
  //   transition: opacity 0.3s;
  //   background: map-get($shades, 'black');
  // }

  // &:hover {
  //   &::before {
  //     opacity: 1;
  //   }
  // }

  &:hover,
  &.router-link-active,
  &.force-active {
    color: $c-pink;
    transform: translate3d(-20px, 0, 0);
    // margin-top: 20px;
    // margin-bottom: 20px;
  }
}

</style>
